import React from 'react';
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
    Navigation,
    Home,
    Vacations,
    Admin,
    PendingRequestsTable,
    GrantDays,
    EmployeeList,
    BankHolidaysForm,
    BankHolidaysList,
    DefaultResponsibleForm,
    ResponsibleForm,
    SearchUserForm
} from "./components";
import { ProtectedRoute, ProtectedRouteAdmin } from './components/common/ProtectedRoute';

function App() {

  return (
    <Router>
      <Navigation />
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/calendario" element={
            <ProtectedRoute>
              <Vacations />
            </ProtectedRoute>
          } />
          <Route path="/administrar" element={
            <ProtectedRouteAdmin>
              <Admin/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/peticiones_pendientes" element={
            <ProtectedRouteAdmin>
              <PendingRequestsTable/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/formulario_dias" element={
            <ProtectedRouteAdmin>
              <GrantDays/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/lista_empleados" element={
            <ProtectedRouteAdmin>
              <EmployeeList/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/formulario_festivos" element={
            <ProtectedRouteAdmin>
              <BankHolidaysForm/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/dias_festivos" element={
            <ProtectedRouteAdmin>
              <BankHolidaysList/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/formulario_responsables" element={
            <ProtectedRouteAdmin>
              <ResponsibleForm/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/formulario_usuarios" element={
            <ProtectedRouteAdmin>
              <SearchUserForm/>
            </ProtectedRouteAdmin>
          } />
          <Route path="/configuracion_responsable" element={
            <ProtectedRouteAdmin>
              <DefaultResponsibleForm/>
            </ProtectedRouteAdmin>
          } />
      </Routes>
    </Router>
  );
}

export default App;
